import { Box } from '@mui/material'
import React from 'react'
import { SmallBold, SmallRegular, LargeBold, Point } from './GettingStarted';
import { Skill } from './UnderstandingSkill';

const UnderstandingCompany = () => {

    const ratings = [
        {
            name: 'Poor',
            bg: '#E75541'
        },
        {
            name: 'Fair',
            bg: '#F6C70E'
        },
        {
            name: 'Good',
            bg: '#49B6FF'
        },
        {
            name: 'Very Good',
            bg: '#95C97A'
        },
        {
            name: 'Best In Class',
            bg: '#07AF22'
        }
    ];

  return (
      <Box>
          <Box mb="45px">
              <Box mb="25px">
                  <LargeBold>
                      Understanding Company Rating Dimensions and Scales: A User
                      Guide
                  </LargeBold>
              </Box>
              <Box mb="10px">
                  <SmallRegular>
                      At Jobfactor, we value your input and insights on your
                      current and previous employers. To provide an accurate and
                      comprehensive assessment of your current employer, we've
                      established a set of dimensions and rating scales. This
                      guide will help you understand each rating dimension and
                      the associated scales, ensuring that your reviews are
                      informative and valuable to others in our community.{' '}
                      <br /> Below are the various scale used in measuring the
                      ratings dimensions:
                  </SmallRegular>
              </Box>
              <Box
                  display="flex"
                  gap="28px"
                  flexWrap="wrap"
                //   alignItems="center"
              >
                  {ratings.map((rating) => (
                      <Skill name={rating.name} disableMargin bg={rating.bg} />
                  ))}
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>1. Compensation and Benefits:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The company offers compensation and benefits well
                      below industry standards.
                  </Point>
                  <Point>
                      {' '}
                      Fair: Compensation and benefits are competitive but may
                      not stand out.
                  </Point>
                  <Point>
                      {' '}
                      Good: The company provides a solid compensation package
                      with reasonable benefits.
                  </Point>
                  <Point>
                      Very Good: Compensation and benefits are above average and
                      attractive.
                  </Point>
                  <Point>
                      Best in Class: The company excels in compensation and
                      offers outstanding benefits compared to others in the
                      industry.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>2. Technology and Innovation:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The company lacks modern technology and innovative
                      practices.
                  </Point>
                  <Point>
                      Fair: Technology and innovation are present but not a
                      strong focus.
                  </Point>
                  <Point>
                      Good: The company embraces current tech trends and
                      encourages innovation.
                  </Point>
                  <Point>
                      Very Good: Technology and innovation are central to the
                      company's culture and operations.
                  </Point>
                  <Point>
                      Best in Class: The company is a technological and
                      innovative leader in its industry.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>
                      3. Office Environment (Remote Included):
                  </SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The office environment is challenging; inflexible
                      and remote work options are limited.
                  </Point>
                  <Point>
                      Fair: The office environment is average, with limited
                      flexibility.
                  </Point>
                  <Point>
                      Good: The company provides a comfortable office
                      environment and reasonable flexibility including remote
                      work options.
                  </Point>
                  <Point>
                      Very Good: The office environment is pleasant, and work
                      schedules are highly flexible.
                  </Point>
                  <Point>
                      Best in Class: The Company offers an exceptional office
                      environment and robust flexibility and remote work
                      opportunities.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>4. Training and Skill Development:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The Company lacks training programs and
                      opportunities for skill development.
                  </Point>
                  <Point>
                      Fair: Limited training and skill development options are
                      available.
                  </Point>
                  <Point>
                      Good: The Company invests in employee training and skill
                      enhancement.
                  </Point>
                  <Point>
                      Very Good: Training and skill development are priorities
                      for the company.
                  </Point>
                  <Point>
                      Best in Class: The Company excels in providing extensive
                      training and skill development resources.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>5. Career Growth Opportunity:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: Career growth is severely limited within the
                      company.
                  </Point>
                  <Point>
                      Fair: Career growth options are limited and somewhat
                      challenging to attain.
                  </Point>
                  <Point>
                      Good: Opportunities for career growth exist and are
                      attainable with effort.
                  </Point>
                  <Point>
                      Very Good: The Company actively promotes career growth and
                      advancement.
                  </Point>
                  <Point>
                      Best in Class: The Company is outstanding in providing
                      diverse and accessible career growth opportunities.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>6. Reward and Recognition:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The company provides minimal recognition and rewards
                      for employees.
                  </Point>
                  <Point>
                      Fair: Recognition and rewards are sporadic and somewhat
                      limited.
                  </Point>
                  <Point>
                      Good: The company acknowledges and rewards employee
                      contributions.
                  </Point>
                  <Point>
                      Very Good: Recognition and rewards are consistent and
                      meaningful.
                  </Point>
                  <Point>
                      Best in Class: The company excels in recognizing and
                      rewarding employees, setting a high standard in the
                      industry.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>7. Work/Life Balance:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: Maintaining work/life balance is extremely
                      challenging at the company.
                  </Point>
                  <Point>
                      Fair: Achieving work/life balance can be difficult but is
                      possible with effort.
                  </Point>
                  <Point>
                      Good: The company supports reasonable work/life balance.
                  </Point>
                  <Point>
                      Very Good: Maintaining work/life balance is encouraged and
                      achievable.
                  </Point>
                  <Point>
                      Best in Class: The company stands out in promoting and
                      enabling a healthy work/life balance.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>
                      8. Community Engagement and Charitable Giving:
                  </SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The Company shows little to no involvement in
                      community engagement or charitable activities.
                  </Point>
                  <Point>
                      Fair: Some community engagement or charitable initiatives
                      are present.
                  </Point>
                  <Point>
                      Good: The company actively participates in community
                      engagement and charitable efforts.
                  </Point>
                  <Point>
                      Very Good: Community engagement and charitable giving are
                      integral to the company's values.
                  </Point>
                  <Point>
                      Best in Class: The Company excels in contributing to the
                      community and charitable causes, setting a high standard.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>9. Company Size:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The Company is too small to provide adequate
                      resources or opportunities.
                  </Point>
                  <Point>
                      Fair: It's a relatively small company with limited growth
                      prospects.
                  </Point>
                  <Point>
                      Good: The Company’s size allows for reasonable stability
                      and growth.
                  </Point>
                  <Point>
                      Very Good: The Company’s size provides ample resources and
                      opportunities.
                  </Point>
                  <Point>
                      Best in Class: The Company’s size is a significant
                      advantage, fostering exceptional growth and opportunities.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>10. Job Security:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: Job security at the company is highly uncertain.
                  </Point>
                  <Point>
                      Fair: Job security is somewhat stable but may have
                      occasional uncertainties.
                  </Point>
                  <Point>
                      Good: The Company offers reasonable job security.
                  </Point>
                  <Point>
                      Very Good: Job security is high, with few concerns.
                  </Point>
                  <Point>
                      Best in Class: The Company excels in providing job
                      security, surpassing industry standards.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>11. Diversity and Inclusion:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: The Company lacks diversity and inclusion efforts.
                      Company actively promotes diversity and inclusion.
                  </Point>
                  <Point>
                      Fair: Limited diversity and inclusion initiatives are in
                      place.
                  </Point>
                  <Point>Good: The</Point>
                  <Point>
                      Very Good: Diversity and inclusion are central to the
                      company's culture.
                  </Point>
                  <Point>
                      Best in Class: The Company sets a high standard for
                      diversity and inclusion in the workplace.
                  </Point>
              </Box>
          </Box>
          <Box mb="32px">
              <Box mb="25px">
                  <SmallBold>12. Management Transparency:</SmallBold>
              </Box>
              <Box>
                  <Point>
                      Poor: Management is highly secretive and lacks
                      transparency.
                  </Point>
                  <Point>
                      Fair: Some information is shared, but transparency could
                      improve.
                  </Point>
                  <Point>
                      Good: The Company maintains reasonable transparency in
                      management practices.
                  </Point>
                  <Point>
                      Very Good: Management is open and transparent in most
                      aspects.
                  </Point>
                  <Point>
                      Best in Class: The Company excels in management
                      transparency, setting a high standard for the industry.
                  </Point>
              </Box>
          </Box>
          <Box>
              <SmallRegular>
                  When rating companies on Jobfactor, we encourage you to
                  consider each dimension carefully and select the appropriate
                  scale that best reflects your experience. Your thoughtful
                  reviews and ratings contribute to a more transparent and
                  informed job market, benefiting both job seekers and
                  employers.
              </SmallRegular>
          </Box>
      </Box>
  );
}

export default UnderstandingCompany
